module.exports = __webpack_public_path__ + "static/media/modernSampleImage.ccb77355.PNG";